import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/api/client";
import { Card, CardContent } from "@/components/ui/card";

export default function AuditLog() {
  const { data } = useQuery({ queryKey: ["audit"], queryFn: () => api.get("/audit").then((r) => r.data), refetchInterval: 30000 });

  return (
    <div className="space-y-4" data-testid="audit-page">
      <div>
        <h1 className="font-display text-3xl font-black tracking-tight">Audit Log</h1>
        <p className="text-sm text-muted-foreground">All privileged actions across the system.</p>
      </div>
      <Card>
        <CardContent className="p-0">
          <table className="data-table w-full">
            <thead className="border-b border-border/60 bg-muted/40 text-left text-xs uppercase tracking-widest text-muted-foreground">
              <tr><th className="px-4 py-3">Time</th><th className="px-4 py-3">Actor</th><th className="px-4 py-3">Role</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Entity</th><th className="px-4 py-3">Details</th></tr>
            </thead>
            <tbody>
              {(data?.items || []).map((a) => (
                <tr key={a.id} className="border-b border-border/40 text-sm">
                  <td className="px-4 py-3 font-mono text-xs">{new Date(a.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">{a.actor_email || "—"}</td>
                  <td className="px-4 py-3 text-xs uppercase">{a.actor_role}</td>
                  <td className="px-4 py-3 font-semibold">{a.action}</td>
                  <td className="px-4 py-3 text-xs">{a.entity_type} · {a.entity_code || a.entity_id?.slice(0, 8)}</td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">{a.details}</td>
                </tr>
              ))}
              {(!data?.items || data.items.length === 0) && (
                <tr><td colSpan={6} className="px-4 py-8 text-center text-sm text-muted-foreground">No audit events yet. All future privileged actions will appear here.</td></tr>
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
